// import React, { useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';

// const PaymentTicket = () => {
//   const { state } = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (!state) return;

//     const handleBack = (event) => {
//       event.preventDefault();
//       navigate(state.previousPage || '/movies', { replace: true });
//     };

//     window.history.pushState(null, '', window.location.href);
//     window.addEventListener('popstate', handleBack);

//     return () => {
//       window.removeEventListener('popstate', handleBack);
//     };
//   }, [state, navigate]);

//   if (!state) {
//     return <p>No booking information available.</p>;
//   }

//   const {
//     movie,
//     theatreId,
//     showtimeId,
//     bookedSeats,
//     date,
//     time,
//     totalPrice,
//     taxes,
//     ticketTotal,
//     transactionId,
//     transactionStatus,
//     paymentMethod,
//     paymentMode,
//     nameOfTheatre
//   } = state;

// console.log('n the paymnet details',movie,
// theatreId,
// showtimeId,
// bookedSeats,
// date,
// time,
// totalPrice,
// taxes,
// ticketTotal,
// transactionId,
// transactionStatus,
// paymentMethod,
// paymentMode,
// nameOfTheatre);

//   const seatNumbersOnly = bookedSeats.map(seat => seat.seatNumber);

//   const handleSendTicket = async () => {
//     const userPhone = prompt("Enter phone number (without +91):", "");

//     if (!userPhone || !/^\d{10}$/.test(userPhone)) {
//       alert("Please enter a valid 10-digit phone number.");
//       return;
//     }

//     const fullPhone = `91${userPhone}`;

//     const payload = {
//       phoneNumber: fullPhone,
//       movie: movie?.name || 'N/A',
//       nameOfTheatre,
//       time,
//       date,
//       seatNumbers: seatNumbersOnly.join(', '),
//       transactionId
//     };

//     try {
//       const res = await fetch("https://ticket.wmdservices.asia/api/payment/sendTicket", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       const data = await res.json();

//       if (data.success) {
//         alert("Ticket sent to WhatsApp successfully!");
//       } else {
//         alert("Failed to send ticket: " + (data.error || "Unknown error"));
//       }
//     } catch (err) {
//       console.error("Error sending ticket:", err);
//       alert("An error occurred while sending the ticket.");
//     }
//   };

//   return (
//     <div style={{ padding: '2rem', maxWidth: '600px', margin: 'auto' }}>
//       <h2 style={{ color: '#2e7d32' }}>🎟️ Ticket Booked Successfully!</h2>
//       <div style={{ marginTop: '1.5rem' }}>
//         <p><strong>Movie:</strong> {movie?.name || 'N/A'}</p>
//         <p><strong>Theatre:</strong> {nameOfTheatre}</p>
//         <p><strong>Showtime:</strong> {time} on {new Date(date).toDateString()}</p>
//         <p><strong>Seats:</strong> {seatNumbersOnly.join(', ')}</p>
//         <p><strong>Taxes:</strong> ₹{parseFloat(taxes).toFixed(2)}</p>
//         <p><strong>Total:</strong> ₹{parseFloat(totalPrice).toFixed(2)}</p>
//       </div>

//       {/* 🚀 Navigate to Movie Details */}
//       <div style={{ marginTop: '2rem', textAlign: 'center' }}>
//         <button
//           onClick={() => navigate("/movies")}
//           style={{
//             padding: '10px 20px',
//             fontSize: '16px',
//             backgroundColor: 'black',
//             color: '#fff',
//             border: 'none',
//             borderRadius: '6px',
//             cursor: 'pointer',
//           }}
//         >
//            Back to Movie
//         </button>

//         <button
//           onClick={handleSendTicket}
//           style={{
//             padding: '10px 20px',
//             fontSize: '16px',
//             backgroundColor: '#007bff',
//             color: '#fff',
//             border: 'none',
//             borderRadius: '6px',
//             cursor: 'pointer',
//           }}
//         >
//           Send Ticket
//         </button>
//       </div>
//     </div>
//   );
// };

// export default PaymentTicket;

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PaymentServices from "../../services/externalServices/TicketServices/paymentServices";
import ScreenLayoutServices from "../../services/externalServices/TicketServices/screenLayoutServices";
import CustomModal from './Component/CustomModal'

const PaymentTicket = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [phoneInput, setPhoneInput] = useState("");
  const [qrUrl, setQrUrl] = useState("");

  const [showModal, setShowModal] = useState(false);

  const {
    movie,
    theatreId,
    showtimeId,
    bookedSeats,
    date,
    time,
    totalPrice,
    taxes,
    ticketTotal,
    transactionId,
    transactionStatus,
    paymentMethod,
    paymentMode,
    nameOfTheatre,
    bookingId,
    sendNoWhatsApp,
    maxTimeLimit,
    code,
    isSectionLayout
  } = state;
  let phoneNumber = state?.phoneNumber || "";

  console.log('state?.phoneNumber', state);

  const seatNumbersOnly = bookedSeats.map((seat) => seat.seatNumber);

  console.log('totalPrice===============', totalPrice);





  const [isNavigating, setIsNavigating] = useState(false);

 
  const handleBackNavigation = async (event) => {
    console.log('details of the navigation%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%')
    if (event) event.preventDefault();

    // First, immediately replace current history with target route
    navigate(`/movieDetails/${movie._id}`, {
      state: { movie },
      replace: true
    });



    try {
      const data = { theatreId, date, time, showtimeId };
      console.log('details of the navigation', data)
      const seatLayout = await ScreenLayoutServices.getBookedScreenLayout(data);

      if (seatLayout?.seatLayout) {

         // Push a blocker state first to prevent back to PhonePe
      window.history.pushState({ id: 'block-phonepe' }, '');
        // Now replace again with the actual desired destination
        // const { date, time, theatreId, maxTimeLimit, showtimeId, movie, nameOfTheatre, code, forceReload = false } = location.state;
        navigate("/bookedSeats", {
          state: { seatLayout, date, time, theatreId, showtimeId, movie, nameOfTheatre,maxTimeLimit,code,isSectionLayout },
          replace: true
        });
      } else {
        navigate(`/movieDetails/${movie._id}`, {
          state: { movie },
          replace: true
        });
      }
    } catch (error) {
      console.error("Failed to fetch seat layout:", error);
      // Already navigated to /movies as initial fallback
    }
  };


// old one

  useEffect(() => {
    if (!state) return;

    // Block any natural back navigation
    const handleBack = (event) => {
      event.preventDefault();
      const currentState = window.history.state;
  
      if (currentState?.id === 'block-phonepe') {
        console.log("🔒 Preventing back to PhonePe");
        // Prevent back to payment page — maybe show a message or stay
        navigate(`/movieDetails/${movie._id}`, { state: { movie }, replace: true });
      } else {
        handleBackNavigation(event);
      }
    };

    // Push a dummy state and replace current entry
    // window.history.pushState({ id: 'payment-ticket-block' }, '');
    window.history.replaceState({ id: 'booked-seat-block' }, '');

    window.addEventListener('popstate', handleBack);

    return () => {
      window.removeEventListener('popstate', handleBack);
      // Clean up our dummy state if needed
      if (window.history.state?.id === 'payment-ticket-block') {
        window.history.back();
      }
    };
  }, [state]);

  

  useEffect(() => {
    let tempPhoneNumber = sessionStorage.getItem("tempPhoneNumber");
    phoneNumber = tempPhoneNumber || state?.phoneNumber;
    console.log("phoneNumber in useEffect", phoneNumber);
    // Avoid auto legacy send when v2 flow sets sendNoWhatsApp=true
    if (phoneNumber && !qrUrl && !sendNoWhatsApp) {
      handleSendTicket();
    }
  }, [phoneNumber, qrUrl, sendNoWhatsApp]);

  if (!state) {
    return <p>No booking information available.</p>;
  }

  const handleSendTicket = async () => {
    // if (!phoneNumber || !/^\d{10}$/.test(phoneNumber)) {
    //   alert("Please enter a valid 10-digit phone number.");
    //   return;
    // }

    const fullPhone = `91${phoneNumber}`;
    console.log("fullPhone", fullPhone);

    // const payload = {
    //   phoneNumber: fullPhone,
    //   movie: movie?.name || "N/A",
    //   nameOfTheatre,
    //   time,
    //   date,
    //   seatNumbers: seatNumbersOnly.join(", "),
    //   transactionId,
    //   bookingId
      
    // };



    const payload = {
      phoneNumber: fullPhone,
      movie: movie?.name || "N/A",
      nameOfTheatre,
      time,
      date,
      seatNumbers: seatNumbersOnly.join(", "),
      transactionId,
      bookingId,
      ...(sendNoWhatsApp !== undefined && { sendNoWhatsApp }),
      isSectionLayout:isSectionLayout
    };

    console.log(' payload?.isSectionLayout=======================', payload?.isSectionLayout);

    try {

      const res = await PaymentServices.sendTicket(payload)

      console.log('send ticket res=======================', JSON.stringify(res, null, 2));
      // console.log('res?.isSectionLayout)=======================', res?.isSectionLayout);

      const data = res;

      if (data.success) {
        // alert("Ticket sent to WhatsApp successfully!");
        setQrUrl(data.qrUrl); // ← store the QR code URL
        setShowPhoneModal(false);
        setPhoneInput("");

        sessionStorage.removeItem("tempPhoneNumber");
        sessionStorage.removeItem("tempPhonePeBooking");
        // Confirm coupon if held
        try {
          const heldBooking = sessionStorage.getItem('couponBookingId');
          if (heldBooking) {
            await PaymentServices.confirmCoupon({ bookingId: heldBooking });
            sessionStorage.removeItem('couponBookingId');
          }
        } catch (e) { console.error('confirmCoupon failed', e); }
      } else {
        alert("Failed to send ticket: " + (data.error || "Unknown error"));
      }
    } catch (err) {
      console.error("Error sending ticket:", err);
      alert("An error occurred while sending the ticket.");
    }
  };

  return (
    <div className="min-h-screen p-8 max-w-2xl mx-auto font-sans">
      <div className="grid grid-col-1 md:grid-col-2 gap-4 items-center">
        <div>
          <h2 className="text-4xl font-bold text-green-500 mb-6">
            🎟️ Ticket Booked Successfully!
          </h2>

          <div className="space-y-3 mb-8">
            <p>
              <span className="font-semibold">Movie:</span>{" "}
              {movie?.name || "N/A"}
            </p>
            <p>
              <span className="font-semibold">Theatre:</span> {nameOfTheatre}
            </p>
            <p>
              <span className="font-semibold">Showtime:</span> {time} on{" "}
              {new Date(date).toDateString()}
            </p>
            <p>
              <span className="font-semibold">Seats:</span>{" "}
              {seatNumbersOnly.join(", ")}
            </p>
            <p>
              <span className="font-semibold">Total:</span> ₹
              {parseFloat(totalPrice).toFixed(2)}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <button
              // onClick={() => navigate("/moviebooking")}
              // onClick={() => navigate(`/movieDetails/${movie._id}`,{
              //   state: { 
              //     movie, 
              //     // include any other necessary state that MovieDetails expects
              //   } 
              // })}

              onClick={handleBackNavigation}
              // onClick={(e) => handleBackNavigation(e)}

              className="flex-1 w-full sm:w-auto px-5 py-3 bg-black text-white rounded-lg font-medium hover:bg-gray-800 transition-colors"
            >
              Return
            </button>

            {/* <button
              onClick={handleBackNavigation}
              disabled={isNavigating}
              className={`flex-1 w-full sm:w-auto px-5 py-3 bg-black text-white rounded-lg font-medium hover:bg-gray-800 transition-colors ${isNavigating ? "opacity-50 cursor-not-allowed" : ""
                }`}
            >
              {isNavigating ? "Loading..." : "Back to Movies"}
            </button> */}

            <button
              onClick={() => setShowPhoneModal(true)}
              disabled={!!qrUrl}
              className={`flex-1 w-full sm:w-auto px-5 py-3 rounded-lg  transition-colors ${qrUrl
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-green-500 text-white"
                }`}
            >
              Send Ticket via WhatsApp
            </button>
          </div>

{/* 
          {showModal && (
        <CustomModal
          message="Please use the 'Back to Movie Details' button for navigation"
          onClose={() => setShowModal(false)}
        />
      )} */}

          {/* Phone Modal */}
          {showPhoneModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
              <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-sm">
                <h3 className="text-xl font-semibold mb-4">
                  Enter Your Phone Number
                </h3>
                <div className="flex mb-4">
                  <span className="px-3 py-2 bg-gray-100 border border-r-0 border-gray-300 rounded-l-md">
                    +91
                  </span>
                  <input
                    type="text"
                    value={phoneInput}
                    onChange={(e) => setPhoneInput(e.target.value)}
                    placeholder="10-digit phone number"
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-r-md focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
                <div className="flex justify-between gap-3">
                  <button
                    onClick={handleSendTicket}
                    className="px-4 py-2 bg-green-700 text-white rounded hover:bg-green-800 transition-colors"
                  >
                    Send
                  </button>
                  <button
                    onClick={() => setShowPhoneModal(false)}
                    className="px-4 py-2 bg-red-700 text-white rounded hover:bg-red-800 transition-colors"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* right side */}
        <div>
          {qrUrl && (
            <div className="text-center mt-8">
              <h3 className="text-lg font-semibold mb-4">
                Your Ticket QR Code
              </h3>
              <div className="inline-block p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                <img
                  src={qrUrl}
                  alt="Ticket QR Code"
                  className="w-48 h-48 object-contain"
                />
              </div>
              <p className="mt-3 text-gray-600">
                Scan this code at the theatre entrance.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentTicket;
